import apiFetch from '../../../../../common/apiFetch'

import { Variation } from '../../articlesContainer'
import { AiVariationContext, ApiReply } from './aiVariationTypes'

export const doHttp = async <T>(
	method: 'GET' | 'PATCH' | 'DELETE' | 'POST',
	path: string,
	body?: any,
	nonJsonReply?: boolean,
) => {
	const response = await apiFetch(path, {
		method,
		headers: {
			'Content-Type': 'application/json',
		},
		body: body ? JSON.stringify(body) : undefined,
	})

	const reply = (await (nonJsonReply ? response.text() : response.json())) as T

	// with json we can parse a neat error message from the reply
	const assumedJsonReply = reply as ApiReply<T>
	if (!nonJsonReply && assumedJsonReply.status === 'error') throw new Error(assumedJsonReply.message)

	return reply
}

export const getApiUrl = (
	context: AiVariationContext,
	forSpecificVariation: Variation | null = null,
	forToken: boolean = false, // for getting or creating access token
) => {
	// we're not logged in
	if (context.token) {
		const tokenParam = `?token=${encodeURIComponent(context.token)}`
		return forSpecificVariation
			? `/external/aivariations/${forSpecificVariation.id}${tokenParam}`
			: `/external/aivariations${tokenParam}`
	}

	// we're logged in
	return forSpecificVariation
		? `/aivariations/${forSpecificVariation.id}`
		: `/campaigns/${context.campaignId}/adgroups/${context.adGroupId}/aivariations` + (forToken ? '/token' : '')
}
